import { render, staticRenderFns } from "./ContestAdwardOrderComponent.vue?vue&type=template&id=3df0fc34"
import script from "./ContestAdwardOrderComponent.vue?vue&type=script&lang=js"
export * from "./ContestAdwardOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports